var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSairOpcoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 6.535 1 4.8025 1.78075 3.529C2.21725 2.81575 2.81575 2.21725 3.529 1.78075C4.80025 1 6.535 1 10 1C13.465 1 15.1975 1 16.471 1.78075C17.1842 2.21725 17.7827 2.81575 18.2192 3.529C19 4.80025 19 6.535 19 10C19 13.465 19 15.1975 18.2192 16.4733C17.7827 17.1843 17.1842 17.7828 16.471 18.2193C15.1997 19 13.465 19 10 19C6.535 19 4.8025 19 3.529 18.2193C2.81654 17.7835 2.21743 17.1852 1.78075 16.4733C1 15.1975 1 13.465 1 10Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8776 14.834C14.9154 14.8692 14.9457 14.9117 14.9667 14.9588C14.9877 15.006 14.999 15.057 14.9999 15.1086C15.0009 15.1602 14.9914 15.2115 14.972 15.2594C14.9527 15.3073 14.9239 15.3508 14.8873 15.3873C14.8508 15.4239 14.8073 15.4527 14.7594 15.472C14.7115 15.4914 14.6602 15.5009 14.6086 15.4999C14.557 15.499 14.506 15.4877 14.4588 15.4667C14.4117 15.4457 14.3692 15.4154 14.334 15.3776L9.99041 11.0346L5.64682 15.3776C5.57391 15.4455 5.47747 15.4825 5.37783 15.4808C5.27819 15.479 5.18312 15.4386 5.11265 15.3682C5.04218 15.2977 5.00182 15.2026 5.00006 15.103C4.9983 15.0033 5.03529 14.9069 5.10323 14.834L9.44618 10.4904L5.10323 6.14682C5.03529 6.07391 4.9983 5.97747 5.00006 5.87783C5.00182 5.77819 5.04218 5.68312 5.11265 5.61265C5.18312 5.54218 5.27819 5.50182 5.37783 5.50006C5.47747 5.4983 5.57391 5.53529 5.64682 5.60323L9.99041 9.94618L14.334 5.60323C14.4069 5.53529 14.5033 5.4983 14.603 5.50006C14.7026 5.50182 14.7977 5.54218 14.8682 5.61265C14.9386 5.68312 14.979 5.77819 14.9808 5.87783C14.9825 5.97747 14.9455 6.07391 14.8776 6.14682L10.5346 10.4904L14.8776 14.834Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSairOpcoes);
export default __webpack_public_path__ + "static/media/sairOpcoes.dbedde907ea2ff238ba764e418277507.svg";
export { ForwardRef as ReactComponent };